import { API_BASE_URL } from "@/config";
import { validateToken } from '@/utils/auth';
import { validate_id } from '@/utils/validations';
import { useToast } from '@/components/Toast/useToast';

export default {
    name: 'IncomeEstimatorForm',
    setup() {
        const { showSuccess, showError } = useToast();
        
        return {
            showSuccess,
            showError
        };
    },
    data() {
        return {
            form: {
                id_number: ''
            },
            error: '',
            json_data: {},
            error_messages: {
                id_number: ''
            }
        };
    },
    emits: ['service_status_complete'],
    watch: {
        'form.id_number': function(val) {
            if (val && val.length == 13) {
                var id_test = validate_id(val);
                if (id_test) {
                    this.error_messages.id_number = '';
                }
                else {
                    this.error_messages.id_number = 'Invalid ID number';
                }
            }
            else {
                this.error_messages.id_number = '';
            }
        }
    },
    methods: {
        validate_fields() {
            this.error_messages = {};

            if (!this.form.id_number) {
                this.error_messages.id_number = 'ID Number is required';
            }

            return Object.keys(this.error_messages).length === 0;
        },

        handle_submit() {
            if (!this.validate_fields()) {
                return;
            }

            const id_number_pattern = /^[0-9]+$/;
            if (!id_number_pattern.test(this.form.id_number)) {
                this.error_messages.id_number = 'ID Number must contain only numbers';
                return;
            }

            const TOKEN = localStorage.getItem('token');
            const INCOME_ESTIMATOR_API = `${API_BASE_URL}/verify_api/instant_verify_api/income_estimator/`;

            this.error = '';

            $.ajax({
                url: INCOME_ESTIMATOR_API,
                method: 'POST',
                contentType: 'application/json',
                headers: {
                    Authorization: `Token ${TOKEN}`
                },
                data: JSON.stringify({
                    id_number: this.form.id_number
                }),
                beforeSend: () => {
                    Swal.fire({
                        text: 'Loading ...',
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading()
                    });
                },
                success: () => {
                    Swal.close();
                    this.showSuccess('Successful', 'Income Estimator ran successfully', 3000);
                    this.$emit('service_status_complete');
                    this.form.id_number = '';
                },
                error: (error) => {
                    Swal.close();
                    let error_message = 'Something went wrong!';
                    if (error.responseJSON && error.responseJSON.message) {
                        error_message = error.responseJSON.message;
                    }
                    this.showError('Error', error_message);
                }
            });
        }
    },
    mounted() {
        if (!validateToken(this.$router)) {
            return;
        }
    }
};
